module.exports = __webpack_public_path__ + "static/media/1009852.c6d75b46.jpg";